





































import {
  EstimateTemplate,
  getEstimateTemplates,
  deleteEstimateTemplate
} from "@/api/estimate-templates-api";
import { Component, Vue } from "vue-property-decorator";
import NewFolderModal from "@/components/NewFolderModal.vue";
import NewFolderRequest from "@/models/new-folder-request";
import {
  savePhotoEntry,
  deletePhotoEntry,
  getTemplateEstimateEntries
} from "@/api/photo-api";
import { FolderEntry, Breadcrumb } from "@/models/file";
import FileExplorer from "@/templates/FileExplorer.vue";

@Component({
  components: {
    NewFolderModal,
    FileExplorer
  }
})
export default class EstimateTemplateListPage extends Vue {
  fields = [
    {
      key: "name",
      label: "見積テンプレート名"
    },
    { key: "actions", label: " " }
  ];

  estimateTemplates: EstimateTemplate[] = [];

  get estimateTemplateData() {
    return this.estimateTemplates;
  }
  get entriesData() {
    const items = this.estimateTemplates.map(template => ({
      entryId: template.id,
      name: template.title,
      isEstimate: true,
      isTemplate: false,
      isEstimateTemplate: true,
      kind: null
    }));

    const entries = this.entries.map(entry => ({
      ...entry,
      isEstimate: false,
      isTemplate: true,
      isEstimateTemplate: true
    }));

    return [...entries, ...items];
  }

  async created() {
    await this.initEntries();
    await this.initEstimateTemplates();
  }

  async initEstimateTemplates() {
    this.estimateTemplates = await getEstimateTemplates(this.currentFolderId);
  }

  newFolderRequest = new NewFolderRequest();
  entries: FolderEntry[] = [];
  path: Breadcrumb[] = [];
  currentFolderId: any = this.$store.state.estimateTemplate.documentId;
  selectedPhoto: FolderEntry | null = null;

  showNewFolderModal() {
    this.newFolderRequest = new NewFolderRequest();
    this.newFolderRequest.name = "新しいフォルダ";
    this.newFolderRequest.serviceId = this.$store.state.serviceId;
    this.newFolderRequest.parentFolderId = this.currentFolderId;
  }

  async addFolder() {
    await savePhotoEntry(this.newFolderRequest.toFormData());
    await this.initEntries();
  }

  async initEntries(changeFolder = true) {
    const { entries, path } = await getTemplateEstimateEntries(
      this.currentFolderId,
      this.$store.state.serviceId
    );
    this.entries = entries;
    const breadcrumbs = this.$store.state.estimateTemplate.breadcumbs;
    this.path = !changeFolder && breadcrumbs.length ? breadcrumbs : path;
  }

  get currenFolderId() {
    const last = this.path[this.path.length - 1];
    return last ? last.id : null;
  }

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  open(entry: FolderEntry) {
    this.changeCurrentFolder(entry);
  }

  changeCurrentFolder(entry: { entryId?: any }) {
    this.currentFolderId = entry.entryId || 0;
    this.initEntries();
    this.initEstimateTemplates();
  }

  async mv(id: any, folderId: any) {
    const entry = this.entriesData.find(e => String(e.entryId) === id);
    if (!entry) return;
    if (entry.entryId === folderId) return;
    const data = new FormData();
    data.append("id", String(entry.entryId));
    data.append("name", entry.name);
    if (entry.kind) data.append("kind", entry.kind);
    data.append("serviceId", this.$store.state.serviceId);
    data.append("parentFolderId", folderId);
    if (entry.isEstimate) data.append("isEstimate", String(entry.isEstimate));
    await savePhotoEntry(data);
    await this.initEntries();
    await this.initEstimateTemplates();
  }

  async renameFolder(entry: FolderEntry, name: string) {
    const data = new FormData();
    data.append("id", String(entry.entryId));
    data.append("name", name);
    data.append("kind", entry.kind);
    data.append("serviceId", this.$store.state.serviceId);
    data.append("parentFolderId", this.currentFolderId);
    await savePhotoEntry(data);
    await this.initEntries();
  }

  async removeFolder(entry: FolderEntry) {
    if (entry.isEstimate) {
      if (!confirm("本当に削除してもよろしいですか？")) return;
      await deleteEstimateTemplate(entry.entryId as string);
    } else {
      await deletePhotoEntry(entry.entryId);
    }
    await this.initEntries();
    await this.initEstimateTemplates();
  }
}
